module.exports = require('./helpers/bundle-url').getBundleURL('i5qVm') + "logo.c51670a8.svg";